// extracted by mini-css-extract-plugin
export default {"intoFormContainer":"PasswordForm_intoFormContainer__qqGZK","modal-footer":"PasswordForm_modal-footer__3j5uS","modal-cancel-button":"PasswordForm_modal-cancel-button__iHDo8"};